import {
  Box,
  Typography,
  Button,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { hideDialog } from "../../../redux/guest-slices/other.slice";
import { handleCompleteAppointment } from "../../../redux/member-slices/appointment.slice";
import { setCurrectChat } from "../../../redux/user-slices/socket.slice";

function AppointmentCompletePopup() {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.otherSlice);
  const { chat } = useSelector((state) => state.socketSlice);


  const handleClose = () => {
    dispatch(hideDialog());
  };

  const handleConfirm = async () => {
    try {
      const res = await dispatch(
        handleCompleteAppointment({
          id: chat?.appointmentId,
          roomId: chat?._id,
        })
      );

      if (res?.payload) {
        dispatch(hideDialog());
        dispatch(setCurrectChat(null));
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <DialogTitle
        sx={{
          fontWeight: 700,
          textAlign: "center",
        }}
      >
        Appointment Completion
      </DialogTitle>

      <DialogContent>
        <Box sx={{ textAlign: "center", py: 1 }}>
          <Typography
            variant="body1"
            sx={{
              mb: 2,
              color: "#555",
            }}
          >
            {data?.message}
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: "#888",
            }}
          >
            Has your appointment been completed successfully?
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          pb: 3,
          justifyContent: "center",
          gap: 1,
        }}
      >
        <Button
          variant="outlined"
          color="error"
          onClick={handleClose}
        >
          No
        </Button>

        <Button
          variant="contained"
          color="success"
          onClick={handleConfirm}
        >
          Yes, Complete
        </Button>
      </DialogActions>
    </>
  );
}

export default AppointmentCompletePopup;